import React from "react";
import * as S from "./styled";
import T from "@marginly/ui/components/typography";
import Space from "../common/space";
import { formatNum } from "util/format";
import { formatPnl, formatScore } from "util/format-pnl";

import Button from "@marginly/ui/components/button";
import { REFER_BADGES } from "components/leaderboard/hooks/use-rating";
import { ShowMoreButton } from "components/leaderboard/styled";
import { ByUserWithPositionRow, LeaderboardRow } from "types/api";
import { isLeaderboardRowList } from "types/type-guards";

interface Props {
  onReferralButtonClick?: () => void;
  onTopRatingButtonClick: () => void;
  list: ByUserWithPositionRow[] | LeaderboardRow[] | undefined;
  userAddress: string | undefined;
  isContestOver: boolean;
  renderImgPath: (value: number) => string;
  renderImgReferPath: (value: number) => string;
  topRank: number;
  contestDates: string;
}

export function LeaderboardSection({
  onReferralButtonClick,
  onTopRatingButtonClick,
  list,
  userAddress,
  renderImgReferPath,
  isContestOver,
  renderImgPath,
  topRank,
  contestDates,
}: Props) {
  const renderList = () => {
    if (!list?.length) return null;
    if (isLeaderboardRowList(list)) {
      return list.slice(0, 5).map((item, key) => {
        return (
          <S.RatingItem key={key}>
            <S.RatingNum className="referral">{key + 1}</S.RatingNum>
            <S.RatingTeamInfo>
              <div>
                <span>
                  {".." +
                    item.userAddress.substring(item.userAddress.length - 4)}
                </span>
                {userAddress == item.userAddress && (
                  <S.YourRank>Your rank</S.YourRank>
                )}
              </div>
            </S.RatingTeamInfo>

            <S.RatingEpicItem>
              <img src={renderImgPath(key + 1)} alt="" />
            </S.RatingEpicItem>
            <S.RatingTotals pnl={item.score}>
              {formatScore(item.score)}%
            </S.RatingTotals>
          </S.RatingItem>
        );
      });
    }
    return list.slice(0, 5).map((item, key) => {
      return (
        <S.RatingItem key={key}>
          <S.RatingNum className="referral">{key + 1}</S.RatingNum>
          <S.RatingTeamInfo>
            <div>
              <span>
                {".." + item.userAddress.substring(item.userAddress.length - 4)}
              </span>
              {userAddress == item.userAddress && (
                <S.YourRank>Your rank</S.YourRank>
              )}
            </div>
          </S.RatingTeamInfo>

          <S.RatingEpicItem>
            <img src={renderImgPath(key + 1)} alt="" />
          </S.RatingEpicItem>
          <S.RatingTotals pnl={item.pnl}>{formatPnl(item.pnl)}</S.RatingTotals>
        </S.RatingItem>
      );
    });
  };

  return (
    <S.LeaderboardGrid>
      {isContestOver ? (
        <S.LeaderboardLeftContestOver>
          <div>
            <T headerL>Contest is over</T>
            <Space height={12} heightMobile={8} />
            <T body secondary>
              {formatNum(list?.length)} participants from {contestDates}.
            </T>
          </div>

          {onReferralButtonClick && (
            <Button text onClick={onReferralButtonClick}>
              <S.TrumbnailGroup>
                {REFER_BADGES.slice(0, 3).map(
                  ({ position, prize, src }, index) => {
                    return (
                      <img
                        key={position}
                        src={renderImgReferPath(index + 1)}
                        alt=""
                        className="coin"
                      />
                    );
                  },
                )}
              </S.TrumbnailGroup>{" "}
              <T action className="button-text">
                Referral Winners
              </T>
            </Button>
          )}
        </S.LeaderboardLeftContestOver>
      ) : (
        <S.LeaderboardLeft>
          <T headerL>Leaderboard</T>
          <Space height={12} heightMobile={8} />
          <T body secondary>
            {formatNum(list?.length)} participants are already competing for
            prizes.
          </T>
        </S.LeaderboardLeft>
      )}

      <div className="rating">
        <S.TeamRating
          onClick={onTopRatingButtonClick}
          className={list ? "" : "pending"}
        >
          <T headerS>Top 5 competitors</T>
          <Space height={14} heightMobile={14} />

          {renderList()}

          <Space height={24} heightMobile={18} />

          {list && <ShowMoreButton>Show Top {topRank}</ShowMoreButton>}
          <div className="pending-div" />
        </S.TeamRating>
      </div>
    </S.LeaderboardGrid>
  );
}
